import { trustItems } from '@/mocks/categories';

export default function TrustStrip() {
  return (
    <section className="bg-background-50 border-b border-background-200/50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-6 md:py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {trustItems.map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-accent-100/70">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 font-label whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}